<template>
  <div
    ref="dropBox"
    class="root"
  >
    <empty-video-page
      v-show="taskList.length == 0"
      upload-btn-tip="支持格式：MP4, MOV, AVI, WMV, FLV，大小不超过 200M"
      @fromLocal="addVideoFromLocal"
      @fromWeb="addVideoFromWeb"
    >
      <span class="tipContent">或者把文件拖拽到此处</span>
      <span class="tipContent">支持格式：MP4, MOV, AVI, WMV, FLV</span>
    </empty-video-page>

    <div
      v-show="taskList.length > 0"
      class="taskEdit"
    >
      <ul
        id="convert-task-list"
        @dragenter.stop
      >
        <li
          v-for="(item, index) in taskList"
          :key="index"
          class="videoItem"
        >
          <div class="info">
            <div class="cove">
              <img
                v-if="item.inputFormat === 'MP4' || item.inputFormat === 'MOV'"
                :src="item.thumbnail"
              >
              <div
                v-if="item.inputFormat !== 'MP4' && item.inputFormat !== 'MOV'"
                class="defaultCover"
              >
                <iconfont
                  name="#icon13-5wufayulan"
                  font-size="23px"
                ></iconfont>
              </div>
            </div>

            <div class="description">
              <!-- <div :title="item.name + '.' + item.inputFormat">
                {{ item.name + '.' + item.inputFormat }}
              </div>-->
              <text-show-tip :text="item.name + '.' + item.inputFormat"></text-show-tip>
              <div>时长: {{ item.durationString ? item.durationString : '未知' }}</div>
            </div>
          </div>
          <!-- 正常状态 -->
          <div
            v-show="item.status == statusCode.notConvert"
            class="normal"
          >
            <div class="title">
              输出格式
            </div>
            <drop-down-menu
              v-model="item.outputFormat"
              class="selectionFormat"
              :menu-list="outputFormats"
            ></drop-down-menu>

            <common-blue-button
              content="转换"
              @click="startConvertTask(item)"
            ></common-blue-button>
            <div
              class="delete"
              @click="clearConvertTask(item)"
            >
              <div>
                <!-- <iconfont
                  name="#icon13-31guanbi"
                  font-size="10px"
                ></iconfont>-->
                <close-button></close-button>
              </div>
            </div>
          </div>
          <!-- 转换中 -->
          <div
            v-show="item.status == statusCode.converting"
            class="convert"
          >
            <common-progress
              class="progress"
              :title="'转换中(' + item.converterProgress + '%)'"
              :progress="item.converterProgress"
            ></common-progress>
            <common-white-button
              content="取消"
              @click="stopConvertTask(item)"
            ></common-white-button>
          </div>
          <!-- 上传中 -->
          <div
            v-show="item.status == statusCode.uploading"
            class="upload"
          >
            <common-progress
              class="progress"
              :title="'上传中(' + item.uploatProgress + '%)'"
              :progress="item.uploatProgress"
            ></common-progress>
            <common-white-button
              content="取消"
              @click="stopUploadTask(item)"
            ></common-white-button>
          </div>
        </li>
      </ul>

      <div class="editBar">
        <add-video-button
          upload-btn-tip="支持格式：MP4, MOV, AVI, WMV, FLV，大小不超过 200M"
          @fromLocal="addVideoFromLocal"
          @fromWeb="addVideoFromWeb"
        ></add-video-button>
        <clear-video-button @click="clearAllTasks"></clear-video-button>
        <div class="clearWatermark">
          <clear-watermark v-model="watermark.clearWatermark"></clear-watermark>
        </div>
      </div>

      <!-- <div
        class="startAll"
        @click="startAllTasks"
      >
        开始转换
      </div>-->
      <common-blue-button
        class="startAll"
        content="开始转换"
        @click="startAllTasks"
      ></common-blue-button>
    </div>

    <drop-box @dropFiles="addVideoFromLocal"></drop-box>
  </div>
</template>

<script>
import { uploadBigFile } from '@/components/commonFunc/upload';
import { getFileExt } from '@/components/commonFunc/getFileType';
import { videoCodeInfo } from '@/components/commonFunc/webApi';
import { start, stop, checkStatus } from '@/components/videoConverter/converterWebApi';
import { mapGetters } from 'vuex';
export default {
  name: 'TaskEdit',
  components: {
    DropDownMenu: () => import('@/components/common/dropDownMenu'),
    DropBox: () => import('@/components/common/dropBox'),
    CloseButton: () => import('@/components/common/closeButton'),
    AddVideoButton: () => import('@/components/common/addVideoButton'),
    ClearVideoButton: () => import('@/components/common/clearVideoButton'),
    ClearWatermark: () => import('@/components/common/clearWatermark'),
    CommonBlueButton: () => import('@/components/common/commonBlueButton'),
    CommonWhiteButton: () => import('@/components/common/commonWhiteButton'),
    EmptyVideoPage: () => import('@/components/common/emptyVideoPage'),
    CommonProgress: () => import('@/components/common/commonProgress'),
    TextShowTip: () => import('@/components/common/textShowTip')
  },
  props: {},
  data() {
    return {
      taskList: [],
      //clearWatermark: true,
      pollConverterTimeOut: null,
      supportFormat: ['MP4', 'MOV', 'AVI', 'WMV', 'FLV'],
      outputFormats: ['MP4', 'MOV', 'AVI', 'WMV', 'FLV'],
      statusCode: {
        faild: -1, //转换失败
        notConvert: 1, //未转换
        converting: 2, //转换中
        convertSuccess: 3, //转换成功
        uploading: 4, //上传中
        notUploaded: 5 //未上传
      },
      parentModel: {
        source: '',
        cover: '',
        thumbnail: '',
        name: '',
        duration: 0, //时长
        durationString: null, //时长string格式
        size: 0,
        inputFormat: '',
        outputFormat: '',
        status: 5, //notConver未转换 convering转换中 converSuccess转换成功  uploading上传中 notUploaded未上传 faild转换失败
        converterProgress: 0,
        uploatProgress: 0,
        file: null,
        url: '',
        convertTaskId: '',
        convertKey: '',
        outputUrl: '',
        outputSize: 0,
        cancelToken: { value: false }
      }
    };
  },
  computed: {
    ...mapGetters({
      watermark: 'common/watermark'
    })
  },
  watch: {
    taskList(val) {
      this.$store.commit('common/setEditing', val.length > 0);
      if (val && !val.length) {
        this.$router.replace({ query: {} });
        this.$store.commit('uploader/setVideoUrlShot', {});
        this.$store.commit('uploader/setVideoUrl', '');
      }
    }
  },
  mounted() {
    this.$store.commit('convert/clearFiles');
    let query = this.$route.query;
    if (query.pipe === '1') {
      let data = this.$store.getters['completed/getPipeFiles'];
      if (data) {
        data.forEach((item) => {
          item.source = '其他工具';
        });
        this.addVideoFromWeb(data);
        if (data[0]) {
          this.$store.commit('uploader/setVideoUrl', data[0].url);
        }
      }
    }
  },
  methods: {
    sensorsData(active, body) {
      this.$sensors.track(active, body);
    },
    //上传文件
    async uploadTask(item) {
      item.status = this.statusCode.uploading;
      let body = {
        file: item.file,
        type: item.inputFormat,
        cancelToken: item.cancelToken,
        progressCallback: (value) => {
          //进度回调
          item.uploatProgress = value;
        }
      };
      let result = await uploadBigFile(body);
      if (result.type === 'Success') {
        item.url = result.data;
        item.status = this.statusCode.notConvert;
        item.file = null;
        this.$store.commit('uploader/setVideoUrl', item.url);
        return true;
      } else if (result.type === 'Cancel') {
        // this.$message({
        //   message: '取消成功',
        //   type: 'success',
        //   center: true
        // });
      } else {
        this.$message({
          message: '上传失败',
          type: 'error',
          center: true
        });
      }
      return false;
    },
    //停止上传文件
    async stopUploadTask(item) {
      item.status = this.statusCode.notUploaded;
      item.cancelToken.value = true;
      let index = this.taskList.indexOf(item);
      if (index > -1) {
        this.taskList.splice(index, 1);
      }
    },
    //开始转换
    async startConvertTask(item) {
      let body = {
        type: 2,
        key: item.url,
        to: item.outputFormat,
        nonwatermark: this.watermark.clearWatermark ? '1' : '0'
      };
      this.sensorsData('toolVideoProcess', {
        tool_type: '转换宝',
        video_source: item.source
      });

      let result = await start(body);
      if (result) {
        item.status = this.statusCode.converting;
        item.convertTaskId = result.taskId;
        item.convertKey = result.key;
        item.outputUrl = result.newkey;
        item.cover = result.thumbnailkey;

        if (!this.pollConverterTimeOut) {
          this.pollConverterTimeOut = setTimeout(() => {
            this.checkTaskStatus(this.taskList);
          }, 1000);
        }
      } else {
        item.status = this.statusCode.notConvert;
        this.$message({
          message: '转换失败',
          type: 'error',
          center: true
        });
      }
    },
    //停止转换
    async stopConvertTask(item) {
      item.status = this.statusCode.notConvert;
      await stop(item.convertTaskId);
      //this.clearConvertTask(item);
    },
    //从列表中删除该任务（本地）
    clearConvertTask(item) {
      this.$modal.show('MessageDialog', {
        content: '是否确认删除该文件？',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value.type == 'Ok') {
            item.cancelToken.value = true;
            let index = this.taskList.indexOf(item);
            if (index > -1) {
              this.taskList.splice(index, 1);
            }
          }
        }
      });
    },
    //检测转换状态
    checkTaskStatus(tasks) {
      let taskRunCount = 0;
      for (let i = 0; i < tasks.length; i++) {
        if (tasks[i].status == this.statusCode.converting) {
          taskRunCount++;
          checkStatus(tasks[i].convertTaskId).then((res) => {
            res = parseFloat(res).toFixed(2);
            if (0 < res && res < 1) {
              tasks[i].converterProgress = parseInt(res * 100);
            } else if (res == 1) {
              tasks[i].converterProgress = 100;
              this.convertSuccess(tasks[i]);
            } else if (res == -1) {
              tasks[i].status == this.statusCode.converting;
            } else if (res == -2) {
              this.convertFaild(tasks[i]);
            }
          });
        }
      }
      if (taskRunCount === 0) {
        clearTimeout(this.pollConverterTimeOut);
        this.pollConverterTimeOut = null;
      } else {
        this.pollConverterTimeOut = setTimeout(() => {
          this.checkTaskStatus(tasks);
        }, 3000);
      }
    },
    //清空列表（本地）
    clearAllTasks() {
      this.$modal.show('MessageDialog', {
        content: '是否确定要清空当前的列表内容？（操作不可恢复）',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value.type == 'Ok') {
            for (let i = 0; i < this.taskList; i++) {
              let task = this.taskList[i];
              if (task.status == this.statusCode.uploading) {
                task.cancelToken.value = true;
                task.status == task.notUploaded;
              } else if (task.status == this.statusCode.converting) {
                stop(task.convertTaskId);
                task.status = this.statusCode.notConvert;
              }
            }
            this.taskList = [];
          }
        }
      });
    },
    //全部转换
    startAllTasks() {
      this.taskList.forEach((task) => {
        if (task.status === this.statusCode.notConvert) {
          this.startConvertTask(task);
        }
      });
    },
    //转换成功
    async convertSuccess(task) {
      task.status = this.statusCode.convertSuccess;
      let index = this.taskList.indexOf(task);
      if (index > -1) {
        this.taskList.splice(index, 1);
      }
      let item = {
        cover: task.cover,
        duration: task.duration,
        durationString: '--:--',
        size: task.size,
        name: task.name,
        url: task.outputUrl,
        outputFormat: task.outputFormat
      };
      this.$store.commit('convert/addFile', item);
      let codeInfo = await videoCodeInfo(task.outputUrl);
      if (codeInfo && codeInfo.format) {
        let format = codeInfo.format;
        item.duration = format.duration;
        let mm = parseInt(item.duration / 60);
        let ss = (item.duration % 60).toFixed(0);
        item.durationString = `${mm.toString().padStart(2, 0)}:${ss.toString().padStart(2, 0)}`;
      }
    },

    convertFaild(task) {
      task.converterProgress = 0;
      task.status = this.statusCode.notConvert;
      this.$message({
        message: `"${task.name}"转换失败`,
        type: 'error',
        center: true
      });
    },

    //检测视频格式
    async checkVideoFormat(file) {
      let fileModel = {
        file: file,
        name: file.name,
        type: file.type,
        size: file.size
      };
      //文件的真实类型
      fileModel.type = await getFileExt(fileModel.file);
      //文件的后缀名
      let fileExt = fileModel.name.replace(/.+\./, '').toUpperCase();
      if (!this.supportFormat.includes(fileModel.type) || !this.supportFormat.includes(fileExt)) {
        this.$message({
          message: `不支持文件"${file.name}"的格式`,
          type: 'error',
          center: true
        });
        return false;
      } else if (fileModel.size > 200 * 1024 * 1024) {
        this.$message({
          message: `文件"${fileModel.name}"大小超过限制`,
          type: 'error',
          center: true
        });
        return false;
      }
      //else if ((await this.$.getDuration(file)) > 3600) {
      //   this.$message({
      //     message: `文件"${file.name}"时长超过限制`,
      //     type: 'error',
      //     center: true
      //   });
      //   return false;
      // }
      return fileModel;
    },
    // 从本地添加视频
    async addVideoFromLocal(files) {
      if (!files.length) return;
      for (let i = 0; i < files.length; i++) {
        if (this.taskList.length > 4) {
          this.$message({
            message: '最多只能存在5个转换任务',
            type: 'warning',
            center: true
          });
          break;
        }

        let file = files[i];
        let checkResult = await this.checkVideoFormat(file);
        if (!checkResult) {
          continue;
        }

        let videoModel = this.createConverObjectFromFile(checkResult);
        this.taskList.push(videoModel);
        this.uploadTask(videoModel).then(async (res) => {
          //上传成功后写神策埋点
          if (res) {
            let codeInfo = await videoCodeInfo(videoModel.url);
            if (codeInfo && codeInfo.format) {
              videoModel.duration = codeInfo.format.duration;
              this.sensorsData('toolVideoUpload', {
                tool_type: '转换宝',
                video_source: videoModel.source,
                video_duration: videoModel.duration,
                video_size: videoModel.size / (1024 * 1024)
              });
            }
          }
        });
      }
      let scroll = this.$refs.dropBox;
      this.$nextTick(() => {
        this.$refs.dropBox.scrollTo(0, scroll.scrollHeight);
      });
    },
    //创建一个待转换的对象
    createConverObjectFromFile(fileModel) {
      let videoModel = JSON.parse(JSON.stringify(this.parentModel));
      videoModel.status = this.statusCode.notUploaded;
      videoModel.file = fileModel.file;
      videoModel.size = fileModel.file.size;
      videoModel.source = '本地上传';
      videoModel.name = fileModel.name.replace(/(.*\/)*([^.]+).*/gi, '$2');
      //videoModel.inputFormat = file.type.replace('video/', '').toUpperCase();
      videoModel.inputFormat = fileModel.type;
      videoModel.outputFormat = this.outputFormats[0];
      let videoElement = document.createElement('video');
      videoElement.setAttribute('src', URL.createObjectURL(fileModel.file));
      videoElement.addEventListener('loadedmetadata', function() {
        videoModel.duration = videoElement.duration;
        let mm = parseInt(videoModel.duration / 60);
        //let mm = (videoElement.duration / 60).toFixed(0);
        let ss = (videoElement.duration % 60).toFixed(0);
        videoModel.durationString = `${mm.toString().padStart(2, 0)}:${ss.toString().padStart(2, 0)}`;
      });
      videoElement.crossOrigin = '';
      videoElement.currentTime = 1;
      videoElement.addEventListener('canplaythrough', () => {
        let canvas = document.createElement('canvas');
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          videoModel.thumbnail = window.URL.createObjectURL(blob);
        }, 'image/png');
      });

      return videoModel;
    },
    //从平台添加视频
    addVideoFromWeb(vidoeInfos) {
      if (!vidoeInfos.length) return;

      for (let i = 0; i < vidoeInfos.length; i++) {
        let videoInfo = vidoeInfos[i];

        if (this.taskList.length > 4) {
          this.$message({
            message: '最多只能存在5个转换任务',
            type: 'warning',
            center: true
          });
          break;
        }
        let videoModel = this.createConverObjectFromWeb(videoInfo);
        this.taskList.push(videoModel);
        this.sensorsData('toolVideoUpload', {
          tool_type: '转换宝',
          video_source: videoModel.source,
          video_duration: videoModel.duration,
          video_size: videoModel.size / (1024 * 1024)
        });
      }

      let scroll = this.$refs.dropBox;
      this.$nextTick(() => {
        this.$refs.dropBox && this.$refs.dropBox.scrollTo(0, scroll.scrollHeight);
      });
    },
    createConverObjectFromWeb(vidoeInfo) {
      let videoModel = JSON.parse(JSON.stringify(this.parentModel));
      videoModel.status = this.statusCode.notConvert;
      videoModel.name = vidoeInfo.name.replace(/(.*\/)*([^.]+).*/gi, '$2');
      videoModel.inputFormat = vidoeInfo.url.replace(/.+\./, '').toUpperCase();
      videoModel.url = vidoeInfo.url;
      videoModel.size = vidoeInfo.size;
      videoModel.source = vidoeInfo.source;
      videoModel.thumbnail = this.$.handleAssetsUrl(vidoeInfo.cover);
      videoModel.duration = vidoeInfo.duration;
      videoModel.outputFormat = this.outputFormats[0];
      let mm = parseInt(videoModel.duration / 60);
      //let mm = (videoModel.duration / 60).toFixed(0);
      let ss = (videoModel.duration % 60).toFixed(0);
      videoModel.durationString = `${mm.toString().padStart(2, 0)}:${ss.toString().padStart(2, 0)}`;
      return videoModel;
    }
  }
};
</script>

<style scoped lang="scss">
.root {
  position: relative;
  min-width: 618px;
  background-color: #fff;
  border-radius: 4px;
  flex-grow: 1;
  margin: 0px 65px 54px 74px;
}

.tipContent {
  margin-top: 13px;
  font-size: 14px;
  color: #333333;
  height: 14px;
  line-height: 14px;
}

.taskEdit {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  padding: 10px 10px 0px 10px;
  margin-bottom: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
  overflow: hidden;
  > ul {
    width: 100%;
    height: 100%;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    .videoItem {
      height: 140px;
      background: #fff;
      border-radius: 4px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      &:nth-of-type(odd) {
        background-color: #f5f6f9;
      }
    }
    @media screen and (max-width: 1600px) {
      .videoItem {
        padding: 25px 10px;
      }
    }
    @media screen and (min-width: 1600px) {
      .videoItem {
        padding: 25px 20px;
      }
    }
    .info {
      display: flex;
      align-items: left;
      flex-grow: 1;
      margin-right: auto;
      .cove {
        width: 158px;
        height: 90px;
        border-radius: 4px;
        //margin-right: 16px;
        background: #f2f4f8;
        border: 1px solid #d7d7d7;

        > img {
          max-height: 100%;
          max-width: 100%;
        }
      }
      .defaultCover {
        width: 100%;
        height: 100%;
        background-color: #5383fd;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .description {
        color: #333333;
        font-size: 14px;
        line-height: 26px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        @media screen and (max-width: 1600px) {
          > div {
            margin-left: 10px;
            width: 90px;
          }
        }
        @media screen and (min-width: 1600px) {
          > div {
            margin-left: 16px;
            width: 202px;
          }
        }

        > div {
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
          overflow: hidden;
          height: 30px;
          line-height: 30px;
        }
      }
    }
    .normal {
      height: 100%;
      margin-right: auto;
      //width: 400px;
      display: flex;
      align-items: center;
      .title {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
      .selectionFormat {
        height: 40px;
      }
      .delete {
        position: relative;
        align-self: flex-start;
        width: 0px;
        height: 0px;

        > div {
          position: absolute;
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      @media screen and (max-width: 1600px) {
        .selectionFormat {
          width: 108px;
          margin-left: 10px;
          margin-right: 10px;
        }
        .delete {
          > div {
            right: -6px;
            top: -23px;
          }
        }
      }
      @media screen and (min-width: 1600px) {
        .selectionFormat {
          width: 180px;
          margin-left: 16px;
          margin-right: 20px;
        }
        .delete {
          > div {
            left: -6px;
            top: -23px;
          }
        }
      }
    }
    .upload,
    .convert {
      height: 100%;
      // width: 300px;
      margin-right: auto;
      display: flex;
      align-items: center;

      @media screen and (max-width: 1600px) {
        .progress {
          width: 176px;
          margin-right: 20px;
        }
      }
      @media screen and (min-width: 1600px) {
        .progress {
          width: 300px;
          margin-right: 20px;
        }
      }
    }

    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &div::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d5d6dc;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #bdbdbe;
    }
  }

  .editBar {
    position: relative;
    height: 30px;
    line-height: 30px;
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .clearWatermark {
      margin-left: auto;
    }
  }

  .startAll {
    margin-top: 60px;
    margin-bottom: 57px;
  }
  @media screen and (max-width: 1600px) {
    .startAll {
      min-height: 30px;
      width: 84px;
      font-size: 12px;
    }
  }
  @media screen and (min-width: 1600px) {
    .startAll {
      min-height: 40px;
      width: 120px;
      font-size: 14px;
    }
  }
}
</style>
